module.exports = __webpack_public_path__ + "b41e4145f1c028807ecd3ef95c7c4d89.png";